import { Components, hooks } from "botframework-webchat-component";
import { memo, useEffect, useState } from "react";
import { useDispatch } from "react-redux";

import { hide } from "../Home/homeVisibilitySlice";
import { Welcome } from "../Home/Welcome";
import { setTextToSearch } from "../Cards/Card/cardTextSlice";
import { CardList } from "../Cards/CardList";

import PromptButton from "../PromptButton/PromptButton";
import iconSend from "../../../../Assets/chat/send.png";
import "./webChat.css";
import { userSendPrompt } from "../../../../store/userSendPromptSlicer";
import { useChatContext } from "../../../../Context/ChatContext";

const { useSendMessage } = hooks;
function WebChat(props: { cardText: string; homeVisibility: boolean }) {
  const [userMessage, setUserMessage] = useState<string>();
  const dispatch = useDispatch();
  const sendMessage = useSendMessage();
  const { inputText, triggerSubmit, setTriggerSubmit } = useChatContext();

  useEffect(() => {
    if (triggerSubmit && inputText.trim()) {
      setTriggerSubmit(false); 
      setTimeout(() => {
        sendMessage(inputText);
        dispatch(setTextToSearch(""));
        dispatch(hide());
        dispatch(userSendPrompt(inputText));
      }, 300); // puedes ajustar el tiempo si lo necesitas
    }
  }, [triggerSubmit]);


  useEffect(() => {
    if (props.cardText !== "") {
      setUserMessage(props.cardText);
    }
  });

  const handleKeyDown = (event: any) => {
    let keyboardEvent = event as KeyboardEvent;
    if (keyboardEvent.key === "Enter" && !keyboardEvent.shiftKey) {
      keyboardEvent.preventDefault();
      sendMessageToBot();
    }
  };

  const handleSubmit = () => {
    sendMessageToBot();
  };

  const sendMessageToBot = () => {
    if (userMessage?.trim() !== "" && userMessage !== undefined) {
      sendMessage(userMessage);
      setUserMessage("");
      dispatch(setTextToSearch(""));
      dispatch(hide());
      dispatch(userSendPrompt(userMessage)) 
    }
  };

  return (

      <Components.AccessKeySinkSurface>
        <div
          className={props.homeVisibility ? 'webchat-content-home' : 'webchat-content'}
        >
          <div className="chat-promp-area">
            <Components.BasicToaster />
            {props.homeVisibility && (
              <>
                <div className="chat-welcome">
                  <Welcome />
                  <CardList />
                </div>
              </>
            )}
            {!props.homeVisibility && (
              <>
                <Components.BasicTranscript />
              </>
            )}
          </div>
          <div className="chat-sendbox">
            <PromptButton cardText={props.cardText}  />
            <Components.BasicSendBox className="content" />
            <div className="textarea-wrapper">
              <textarea
                id="sendbox-textarea"
                placeholder="What other questions do you have?"
                value={userMessage}
                onChange={(event) => setUserMessage(event.target.value)}
                rows={4}
                cols={50}
                onKeyDown={handleKeyDown}
              ></textarea>

              <button onClick={handleSubmit} id="send-message-button">
                <img
                  src={iconSend}
                  alt="Send"
                  className="send-button-icon"
                />
              </button>
            </div>

            <Components.BasicConnectivityStatus />
           
          </div>
        </div>
      </Components.AccessKeySinkSurface>
    
  );
}

export default memo(WebChat);
